import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-availability-room-1-skeleton',
    imports: [SkeletonModule],
    templateUrl: './availability-room-1-skeleton.component.html',
    styleUrl: './availability-room-1-skeleton.component.scss'
})
export class AvailabilityRoom1SkeletonComponent {

}
